var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 792,
    viewBox: "0 0 613 792",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.978 117.628L51.7045 118.03L51.5845 152.293L51.008 152.291L51.2351 251.99L50.871 355.901L660.419 360.845L660.465 347.646L660.846 238.961L661.738 -15.7599C661.74 -16.3216 661.743 -17.1641 661.745 -17.7258C661.824 -40.1929 643.154 -58.5131 620.098 -58.5939C597.041 -58.6747 578.244 -40.4858 578.165 -18.0187C578.163 -17.457 578.16 -16.6145 578.158 -16.0528L577.87 -16.0538L577.978 117.628ZM134.632 222.232L577.894 223.786L577.789 253.835L134.527 252.282L134.632 222.232ZM415.888 726.487C397.724 728.39 378.41 729.445 358.236 729.375C251.023 728.999 170.717 698.948 117.031 639.222C71.9551 589.916 49.7062 523.84 49.9955 441.274L50.1962 383.983L132.047 384.269L131.854 439.314C131.636 501.66 151.936 548.07 192.752 579.387C230.695 608.166 285.691 622.962 357.743 623.215C378.782 623.288 398.096 622.233 416.262 619.769L415.888 726.487Z",
    fill: "url(#paint0_linear_32_429)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_429",
    x1: 356.835,
    y1: -59.5163,
    x2: 354.072,
    y2: 729.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 788.881,
    height: 610.218,
    fill: "white",
    transform: "translate(612.978 2.13812) rotate(90.2008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.6e9109ffba8b51dc342167b7f348d4c4.svg";
export { ForwardRef as ReactComponent };